import React, { useState, useEffect, useContext } from 'react';

import moment from 'moment';

import { AssignContext, AssignDispatchContext } from '../AssignProvider';

import VenueDayDetails from './selectedVenue/VenueDayDetails';
import VenuePacks from './selectedVenue/VenuePacks';
import VenueSchedules from './selectedVenue/VenueSchedules';

import MinusIcon from 'Assets/icons/minus.svg';
import PlusIcon from 'Assets/icons/plus.svg';

function VenueDetails() {
    const [collapsed, setCollapsed] = useState(false);

    const { selectedVenue, selectedDates, formattedDate, formattedDates, filterDays, filterDay, calendarEvents } = useContext(AssignContext);
    const assignAction = useContext(AssignDispatchContext);
    const [schedules, setSchedules] = useState([]);
    const [daysSchedule, setDaysSchedule] = useState([]);

    const defaultScheduleObj = () => {
        return {
            date: false,
            start: false,
            end: false,
            duration: false,
        };
    };

    useEffect(() => {
        if (selectedVenue && selectedDates.length) {
            if (calendarEvents.length) {
                const filtered = calendarEvents.filter((e) => {
                    return filterDays.includes(e.schedDay);
                });

                if (filtered.length) {
                    setDaysSchedule((oldDaysSchedule) => {
                        let res = [];
                        let scheduleList = [];

                        filtered.forEach((item) => {
                            if (item.schedules && item.schedules.length) {
                                const nds = {
                                    date: item.schedDay,
                                };
                                const sortedSchedules = item.schedules.slice().sort((a, b) => {
                                    const startA = moment(a.start).format('YYYYMMDDHHmm');
                                    const startB = moment(b.start).format('YYYYMMDDHHmm');
                                    return startA - startB;
                                });
                                const sortedSchedulesBackwards = item.schedules.slice().sort((a, b) => {
                                    const startA = moment(a.start).format('YYYYMMDDHHmm');
                                    const startB = moment(b.start).format('YYYYMMDDHHmm');
                                    return startB - startA;
                                });
                                const dayStart = moment(sortedSchedules[0].start);
                                const dayEnd = moment(sortedSchedulesBackwards[0].end);
                                nds.start = dayStart.format('HH:mm');
                                nds.end = dayEnd.format('HH:mm');
                                nds.duration = moment.utc(dayEnd.diff(dayStart)).format('HH:mm');

                                scheduleList = scheduleList.concat(sortedSchedules);
                                res.push(nds);
                            }
                        });

                        setSchedules(scheduleList);
                        return res;
                    });
                } else {
                    setDaysSchedule([]);
                    setSchedules([]);
                }
            }
        } else {
            setDaysSchedule([]);
            setSchedules([]);
        }
    }, [filterDay, filterDays]);

    useEffect(() => {
        assignAction('selectSchedules', { schedules: daysSchedule });
    }, [schedules, filterDays, daysSchedule]);

    return (
        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200">
            <div className="tw-p-2.5 tw-space-y-4">
                {(selectedVenue && (
                    <>
                        <div className="tw-flex tw-gap-4">
                            <div className="tw-basis-full tw-text-lg">
                                <VenueDetailsTitle venueName={selectedVenue.name} date={formattedDate} dates={formattedDates} />
                            </div>

                            <div className="tw-flex tw-items-center tw-justify-end tw-space-x-3">
                                <button className="table__icon-btn tw-text-white" onClick={() => setCollapsed((state) => !state)}>
                                    {collapsed ? <PlusIcon className="tw-w-3.5 tw-h-3.5" /> : <MinusIcon className="tw-w-3.5 tw-h-3.5" />}
                                </button>
                            </div>
                        </div>

                        {!collapsed && (
                            <div className="tw-space-y-3">
                                <VenueSchedules schedules={schedules} date={formattedDate} />
                                {schedules.length > 0 && <VenueDayDetails daysSchedules={daysSchedule} />}
                                <VenuePacks venue={selectedVenue} dates={selectedDates} />
                            </div>
                        )}
                    </>
                )) || <NoVenueSelected />}
            </div>
        </div>
    );
}

export default VenueDetails;

const VenueDetailsTitle = ({ venueName, date, dates }) => {
    if (dates.length > 1) {
        return $t('{{venue_name}} - {{dates}} days from {{date_from}} to {{date_to}}', {
            venue_name: venueName,
            dates: dates.length,
            date_from: dates[0],
            date_to: dates.slice(-1),
        });
    } else if (dates.length === 1) {
        return `${venueName} - ${dates.slice(-1)}`;
    }

    return $t('{{venue_name}} - No selected dates', {
        venue_name: venueName,
    });
};

const NoVenueSelected = () => {
    return <p className="tw-text-sm tw-text-charcoal-50">{$t('No venue selected')}</p>;
};
